import { PayloadAction } from '@reduxjs/toolkit';

import { API, getAsyncThunk } from 'app/api';

import { TransformedSiteConfigs } from './transform-preset-item';

// ---

export type ChangeConfigValuePayload<T extends keyof TransformedSiteConfigs> = {
  name: T;
  value: TransformedSiteConfigs[T];
};

export type ChangeConfigValue<
  T extends keyof TransformedSiteConfigs
> = PayloadAction<ChangeConfigValuePayload<T>>;

export const getSiteConfigs = getAsyncThunk(
  'SITE_CONFIGS:GET_SITE_CONFIGS',
  API.siteConfigs.fetchSiteConfigs,
);
